
import { Options, Vue } from 'vue-class-component';
import LastBalanceV1 from '../last-balance-v1/index.vue';
import LastBalanceV2 from '../last-balance-v2/index.vue';
import { FlagPermissionLastBalance } from '@/feature-flags/flags-permission-last-balance';

@Options({
  components: {
    LastBalanceV1,
    LastBalanceV2
  }
})
class ConfigLastBalance extends Vue {
  get renderedPage() {
    return FlagPermissionLastBalance.permission_v2_enable.isEnabled() ? "LastBalanceV2" : "LastBalanceV1"
  }
}

export default ConfigLastBalance
